import { useState } from 'react';
import { clsx } from 'clsx';

/**
 * The ZenSpace lockup, for the three dark grounds it appears on: the sign-in
 * hero, the organisation picker's header, and the sidebar.
 *
 * The file is the white-wordmark horizontal logo shipped with the rest of the
 * product (`zs-admin`, `zs-meeting-room-display`). If it is missing from a
 * build — an asset pipeline that did not copy `public/`, say — the wordmark is
 * set in type instead, because a header with a broken image in it looks like a
 * broken deployment even when everything behind it is fine.
 */
export function Logo({ width = 163, className }: { width?: number; className?: string }) {
  const [missing, setMissing] = useState(false);

  if (missing) {
    return (
      <span
        className={clsx('text-subheading leading-none font-semibold', className)}
        style={{ width }}
      >
        ZenSpace
      </span>
    );
  }

  return (
    <img
      src="/images/zenspace-logo-white.png"
      alt="ZenSpace"
      width={width}
      style={{ width }}
      className={clsx('h-auto', className)}
      onError={() => setMissing(true)}
    />
  );
}
